export default {
  deforestation: {
    producerData: {
      addProducers: "TAMBAHKAN PRODUSER BARU",
      countryInfo:
        "Kolom untuk memasukkan atau menampilkan negara yang terkait dengan produsen.",
    },
    selectFileToUpload: "Pilih file untuk mengunggah data",
    uploadedToEU: "Diunggah ke Portal UE",
    pending: "Menunggu",
    underReview: "Sedang Ditinjau",
    compliant: "Patuh",
    nonCompliant: "Tidak Mematuhi",
    analyzeDeforestation: "Menganalisis Deforestasi",
    readyToProceed: "Siap Untuk Melanjutkan",
    processingFarm: "Memproses Peternakan",
    mitigationRequired: "Diperlukan Mitigasi",

    veryHighDeforestationProbability: "Probabilitas Deforestasi Sangat Tinggi",
    highDeforestationProbability: "Probabilitas Deforestasi Tinggi",
    mediumDeforestationProbability: "Probabilitas Deforestasi Sedang",
    lowDeforestationProbability: "Probabilitas Deforestasi Rendah",
    veryLowDeforestationProbability: "Probabilitas Deforestasi Sangat Rendah",
    zeroNegligibleDeforestationProbability:
      "Probabilitas Deforestasi Nol/Negligible",
    manuallyMitigated: "Mitigasi Manual",

    internalReferenceNumberMustBeAlphanumeric:
      "Nomor referensi internal harus berupa alfanumerik",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired:
      "Setidaknya salah satu dari ID Pemasok atau Nama Pemasok diperlukan",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired:
      "Setidaknya salah satu dari ID Operator atau Nama Operator diperlukan",
    netMassIsRequired: "Massa bersih diperlukan",
    netMassMustBeValid: "Massa bersih harus valid",
    thisFieldIsRequired: "Kolom ini wajib diisi",
    volumeMustBeNumeric: "Volume harus berupa angka",
    nameIsRequired: "Nama wajib diisi",
    lastNameIsRequired: "Nama belakang wajib diisi",
    firstNameIsRequired: "Nama depan wajib diisi",
    countryIsRequired: "Negara wajib diisi",

    confirmPdfDownload:
      "Apakah Anda ingin mengunduh semua lampiran dalam format PDF?",
    confirmJsonDownload:
      "Apakah Anda ingin mengunduh semua lampiran dalam format JSON?",
    basicFinalFarmListWithStatus: "Daftar final pertanian dasar dengan status",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities:
      "Informasi terperinci, termasuk deskripsi kegiatan mitigasi risiko",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments:
      "Dokumen lengkap, termasuk mitigasi risiko dan dokumen lampiran",

    existing: "Ada",
    survey: "Survei",

    operatorInformation: "Informasi Operator",

    reportAddedSuccessfully: "Laporan berhasil ditambahkan",
    reportUpdatedSuccessfully: "Laporan berhasil diperbarui",
    itemDeletedSuccessfully: "Item berhasil dihapus.",
    reportDeletedSuccessfully: "Laporan berhasil dihapus",
    anErrorOccurredWhileDeletingTheReport:
      "Terjadi kesalahan saat menghapus laporan.",

    valueMustBeBetween02And40: "Nilai harus antara 0,2 dan 40",

    EUDRDeforestationStatusTT:
      "Pemilihan status deforestasi. Kemungkinan Deforestasi Tinggi: Kategori khusus penilaian risiko yang diberikan ke area geografis tertentu berdasarkan kemungkinan deforestasi atau degradasi hutan. Ini membantu menentukan persyaratan uji tuntas bagi operator yang menempatkan komoditas penting (seperti kakao, kopi, dll.) atau produk yang mengandung atau dibuat dari komoditas tersebut di pasar UE. Kemungkinan Deforestasi Rendah: Kategori penilaian risiko untuk area geografis yang dianggap tidak mungkin mengalami deforestasi atau degradasi hutan yang signifikan. Penunjukan ini memengaruhi persyaratan uji tuntas bagi operator yang menempatkan komoditas atau produk dari area ini di pasar UE. Kemungkinan Deforestasi Nol/Tidak Signifikan: Kemungkinan deforestasi sangat rendah atau tidak ada. Ini menunjukkan bahwa risiko atau dampak deforestasi dianggap sangat kecil atau tidak signifikan.",

    complianceRiskWarnings: "Peringatan Risiko Kepatuhan",
    complianceRiskWarningsInfo:
      "Menampilkan judul bagian, menunjukkan bahwa area ini berfokus pada peringatan terkait risiko kepatuhan dalam proses uji tuntas.",
    locationVerificationTT:
      "Mengacu pada proses konfirmasi dan validasi lokasi geografis situs produksi sebagai bagian dari prosedur uji tuntas. Ini mencakup memastikan bahwa detail lokasi yang diberikan, seperti koordinat atau alamat, secara akurat mewakili lokasi fisik tempat kegiatan produksi berlangsung. Verifikasi ini penting untuk menilai dampak lingkungan, kepatuhan penggunaan lahan, dan akurasi data yang dilaporkan dalam laporan uji tuntas.",

    netMassKg: "Massa Bersih (kg)",
    volumeM3: "Volume (m3)",
    warning: "Peringatan",

    productionPlacesTT: "Lokasi di mana barang diproduksi atau dibudidayakan.",
    productionPlacesCountryInfo:
      "Sebuah badan teritorial yang berbeda dengan pemerintahan dan batasnya sendiri.",
    productionPlacesProducersInfo:
      "Entitas yang bertanggung jawab untuk menciptakan atau menumbuhkan barang.",
    totalsTT:
      "Bagian 'Total' memberikan ringkasan indikator kuantitatif utama untuk seluruh kumpulan data atau laporan. Ini mengumpulkan data untuk memberikan pengguna gambaran cepat tentang metrik keseluruhan, seperti massa total produk, volume total produk, luas tempat produksi, dll., yang terlibat dalam laporan uji tuntas.",

    AnalysisOfDeforestationStatusTT:
      "Analisis keadaan deforestasi saat ini dalam area tertentu, biasanya dilakukan untuk menilai dampak lingkungan atau kepatuhan terhadap upaya konservasi.",

    complete: "Lengkap",

    undoDelete: "Batalkan Penghapusan",

    verifyingLocationsData: "Memverifikasi data lokasi...",
    crossCheckingWithProductionPlaces:
      "Memeriksa silang dengan tempat produksi...",
    almostTherePleaseHoldOn: "Hampir selesai, harap tunggu...",
    LocationVerifiedSuccessfully: "Lokasi berhasil diverifikasi!",
    allProductionPlacesAndLocationsHaveBeenConfirmed:
      "Semua tempat produksi dan lokasi telah dikonfirmasi!",
    errorCheckingOverlaps: "Kesalahan memeriksa tumpang tindih.",
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon:
      "Lahan lebih besar dari 4 hektar, harus berbentuk poligon",
    failedToFetchSettings: "Gagal mengambil pengaturan",
    farmCountryNotDefined: "Negara lahan tidak ditentukan.",
    theGeofencesSupposeToBeIn: "Geofence seharusnya berada di",
    butItsIn: "tetapi ada di",
    geofenceIsInOcean: "Geofence atau sebagian dari geofence berada di laut.",

    existingReport: "Laporan Deforestasi yang Ada",
    dimitraReport: "Laporan Deforestasi Dimitra",
    oneForAllFarms: "Satu untuk Semua Peternakan",
    oneForEachFarm: "Satu untuk Setiap Peternakan",

    anErrorOccuredWhileFetchingTheDeforestationReport:
      "Terjadi kesalahan saat mengambil laporan deforestasi.",

    attachRiskMigrationDocTT:
      "Menunjukkan tindakan menghubungkan atau mengaitkan satu dokumen dengan semua pertanian yang teridentifikasi memiliki risiko deforestasi, biasanya untuk tujuan dokumentasi atau kepatuhan regulasi.",
    country: "Negara",
    noOfFarms: "Jumlah Ladang",
    deforestationComplianceReport: "Laporan Kepatuhan Deforestasi",
    noDeforestationComplianceReport:
      "Tidak Ada Laporan Kepatuhan Deforestasi Ditemukan",
    loadingDeforestationComplianceReport:
      "Memuat Laporan Kepatuhan Deforestasi",
    farmName: "Nama Peternakan",
    farmRegistrationId: "ID Registrasi Peternakan",
    farmerName: "Nama Petani",
    farmerRegistrationId: "ID Registrasi Petani",
    uniqueFarmerId: "ID Petani Unik",
    uniqueFarmId: "ID Peternakan Unik",
    farmLocation: "Lokasi Peternakan",
    area: "Area",
    farmAddress: "Alamat Peternakan",
    dateOfRequest: "Tanggal Permintaan",
    status: "Status",
    settings: "Pengaturan",
    farmLatitude: "Lintang Peternakan",
    farmLongitude: "Bujur Peternakan",
    shareQRCode: "Bagikan Kode QR",
    copy: "Salin",
    allCountries: "Semua Negara",
    allRegions: "Semua Daerah",
    allFarms: "Semua Peternakan",
    viewCertificate: "Lihat Sertifikat",
    assignmentIssued: "Tugas Diberikan",
    complianceCertification: "Sertifikasi Kepatuhan",
    noComplianceCertification: "Tidak Ada Sertifikasi Kepatuhan Ditemukan",
    loadingComplianceCertification: "Memuat Sertifikasi Kepatuhan",
    eudrForestAssessment: "Evaluasi Hutan EUDR",
    assessmentReport: "Laporan Evaluasi",
    downloadPDF: "Unduh PDF",
    back: "Kembali",
    farmDetails: "Detail Peternakan",
    dimitraFarmId: "ID Peternakan Dimitra",
    dimitraFermerId: "ID Petani Dimitra",
    totalGeofenceAreaHA: "Total Area Geofence (HA)",
    forestLossHA: "Kehilangan Hutan (HA)",
    forestGainHA: "Pendapatan Hutan (HA)",
    forestUnchangedHA: "Hutan Tidak Berubah (HA)",
    shareCertificate: "Bagikan Sertifikat",
    forestUnchanged: "Hutan Tidak Berubah",
    forestLoss: "Kehilangan Hutan",
    forestGain: "Pendapatan Hutan",
    totalGeofenceArea: "Total Area Geofence",
    deforestationProbability: "Probabilitas Deforestasi",
    colorCode: "Kode Warna",
    geofenceArea: "Area Geofence",
    percentageOfGeofenceArea: "Persentase Area Geofence",
    view: "Tampilan",
    customization: "Penyesuaian",
    recordsPerpage: "Rekaman per Halaman",
    restoreDefault: "Pulihkan Default",
    apply: "Terapkan",
    forestAssessmentHelp:
      "Jika Anda memiliki pertanyaan tentang laporan ini atau memerlukan bantuan memahaminya, hubungi kami melalui Help Desk.",
    overallDeforestationProbability: "Probabilitas Deforestasi Keseluruhan",
    zeroOrNeglegible: "Nol atau Tidak Signifikan",
    high: "Tinggi",
    allStatus: "Semua Status",
    low: "Rendah",
    assessmentIssued: "Evaluasi Dikeluarkan",
    certificateIssued: "Sertifikat Dikeluarkan",
    assessmentNo: "Nomor Evaluasi",
    blockchainCertificateDesc:
      "Hash Validasi Sertifikat Blockchain Akan Tersedia Setelah Penerimaan Sertifikat",
    blockchainValidation: "Validasi Sertifikat Blockchain",
    openBlockchainPage: "Buka Halaman Blockchain",
    clickLinkDesc:
      "Klik pada tautan di atas untuk memvalidasi sertifikat di blockchain",
    "Zero/Negligible Deforestation Probability":
      "Probabilitas Deforestasi Nol/Negligible",
    "Zero Deforestation Probability": "Probabilitas Deforestasi Nol",
    "Low Deforestation Probability": "Probabilitas Deforestasi Rendah",
    "High Deforestation Probability": "Probabilitas Deforestasi Tinggi",
    "Very Low Deforestation Probability":
      "Probabilitas Deforestasi Sangat Rendah",
    "Medium Deforestation Probability": "Probabilitas Deforestasi Sedang",
    "Very High Deforestation Probability":
      "Probabilitas Deforestasi Sangat Tinggi",
    disputeReason: "Alasan Sengketa",
    disputeStatus: "Status Sengketa",
    farmRegId: "ID Reg. Pertanian",
    productionPlaceId: "ID Tempat Produksi",
    disputeId: "ID Sengketa",
    disputeArea: "Ukuran Area",
    disputeResolution: "Penyelesaian Sengketa",
    selectDefaultMeasurementUnit: "Pilih Unit Pengukuran Default",
    selectDefaultMeasurementUnitInfo:
      "Memungkinkan pemilihan satuan default untuk pengukuran, termasuk menentukan satuan, menetapkan batas maksimum, dan menandainya sebagai opsi default.",
    maxLimit: "Batas Maksimum",
    maxLimitInfo:
      "Menetapkan nilai atau ambang batas tertinggi yang diizinkan untuk parameter tertentu.",
    asDefault: "Tandai sebagai Default",
    productMass: "Massa Produk",
    productMassUnitInfo: "Menentukan satuan untuk mengukur massa suatu produk.",
    volumeUnitInfo: "Menentukan satuan untuk mengukur volume suatu produk.",
    operatorInfo:
      "Merujuk pada individu atau entitas yang bertanggung jawab untuk mengelola atau mengoperasikan sistem atau proses.",
    supplierInfo:
      "Entitas yang menyediakan barang atau layanan kepada entitas lain.",
    userTypeInfo:
      "Mengklasifikasikan individu atau entitas berdasarkan peran atau izin mereka dalam sistem.",
    unit: "Unit",
    userType: "Tipe Pengguna",
    eudrPortalApiKeys: "Kunci API Portal EUDR",
    apiKey: "Kunci API",
    apiSecret: "Rahasia API",
    headingCreatedSuccessfully: "Judul berhasil dibuat",
    headingOrderSuccessfullyUpdated: "Urutan berhasil diperbarui",
    headingUpdatedSuccessfully: "Diperbarui dengan sukses",
    assessmentRiskMitigationLvl: "Tingkat Mitigasi Risiko Penilaian",
    assessmentRiskMitigationLvlInfo:
      "Mengategorikan tingkat keparahan risiko yang terkait dengan penggunaan lahan, praktik kehutanan, dan ekspansi pertanian. Tingkat ini membantu mengidentifikasi dampak potensial dari kegiatan pada area hutan dan membimbing tindakan yang tepat untuk mengurangi konsekuensi negatif. Mengategorikan tingkat strategi mitigasi risiko, termasuk sangat tinggi, tinggi, sedang, rendah, dan nol/tidak signifikan.",
    dynamicExpiryTime: "Periode Kedaluwarsa Dinamis",
    dynamicExpiryTimeInfo:
      "Menetapkan periode waktu setelah mana data atau pengaturan tertentu kedaluwarsa secara otomatis. Mengonfigurasi pengaturan terkait laporan deforestasi, termasuk opsi untuk pembaruan otomatis.",
    eudrDeforestationAssessment: "Penilaian Deforestasi EUDR",
    autoRenewalIf:
      "Perpanjangan Otomatis Saat Ditambahkan ke Laporan Due Diligence",
    declarationStatements: "Pernyataan Deklarasi",
    declarationStatementsInfo:
      "Pernyataan yang dibuat oleh pihak yang bertanggung jawab yang memverifikasi akurasi, kelengkapan, dan keaslian informasi yang terkandung dalam laporan.",
    filterDeclaration: "Saring Pernyataan Deklarasi",
    declarationTitle: "Judul Deklarasi",
    declarationTitleInfo:
      "Judul atau heading untuk pernyataan deklarasi, memberikan konteks atau merangkum isinya.",
    applicableCountry: "Negara yang Berlaku",
    applicableCountryInfo:
      "Mendaftarkan negara-negara yang berlaku untuk pengaturan atau peraturan tertentu.",
    addMore: "Tambahkan Lagi",
    autoRenewal: "Perpanjangan Otomatis",
    createNewAssessment: "Buat Penilaian Baru",
    userDimitraAssessment: "Gunakan Penilaian Dimitra",
    shipmentList: "Daftar Pengiriman",
    generalData: "Data Umum",
    check: "Periksa",
    allProducer: "Semua Produsen",
    very_high: "Sangat Tinggi",
    very_low: "Sangat Rendah",
    tooltip: {
      dimitraFarmId:
        "Pengenal unik yang terkait dengan peternakan tertentu dalam sistem Dimitra.",
      farmName: "Nama yang ditetapkan untuk peternakan.",
      farmRegistrationId: "Nomor registrasi peternakan.",
      farmLocation: "Koordinat geografis atau lokasi spesifik peternakan.",
      dimitraFermerId:
        "Pengenal yang berbeda yang terkait dengan petani individu dalam sistem Dimitra.",
      farmerName:
        "Identifikasi individu yang bertanggung jawab atas peternakan.",
      farmerRegistrationId: "Nomor registrasi petani.",
      assessmentNo: "Nomor unik yang diberikan untuk penilaian.",
    },
    red: "Merah",
    Yellow: "Kuning",
    transparent: "Transparan",
    zeroOrNeglegibleProbability:
      "Probabilitas Deforestasi Nol/Tidak Signifikan",
    eudrComplianceStatus: "Status Kepatuhan EUDR",
    zeroOrNegligible: "Nol/Nihil",
    veryHigh: "Sangat Tinggi",
    medium: "Sedang",
    veryLow: "Sangat Rendah",
    darkRed: "Merah Gelap",
    brightRed: "Merah Cerah",
    orange: "Oranye",
    lightBlue: "Biru Muda",
    teal: "Hijau Biru",
    zeroOrNegligibleProbability: "Probabilitas Deforestasi Nol/Nihil",
    veryLowProbability: "Probabilitas Deforestasi Sangat Rendah",
    lowProbability: "Probabilitas Deforestasi Rendah",
    mediumProbability: "Probabilitas Deforestasi Sedang",
    highProbability: "Probabilitas Deforestasi Tinggi",
    veryHighProbability: "Probabilitas Deforestasi Sangat Tinggi",
    locationName: "Nama Lokasi",
    Orange: "Oranye",
    approve: "Setujui",
    approveMessage:
      "Apakah Anda yakin ingin menyetujui laporan ini? Dengan menyetujui laporan ini, laporan tersebut akan diunggah secara permanen ke blockchain. Tautan blockchain dan kode QR akan dibuat, dan tidak ada pembaruan atau penyuntingan lebih lanjut yang dapat dilakukan. Apakah Anda ingin melanjutkan?",
    dueDeligence: "Kewajiban Hati-hati",
    supplierInformation: "Informasi Pemasok",
    name: "Nama",
    lastName: "Nama Belakang",
    email: "Email",
    phoneNumber: "Nomor Telepon",
    enterSupplierName: "Masukkan Nama Pemasok",
    enterSupplierLastName: "Masukkan Nama Belakang Pemasok",
    enterSupplierFirstName: "Masukkan Nama Depan Pemasok",
    enterOperatorName: "Masukkan Nama Operator",
    enterPhoneNumber: "Masukkan Nomor Telepon",
    whoWillAddPlace: "Siapa yang Akan Menambahkan Data Tempat Produksi?",
    companyId: "ID Perusahaan",
    activity: "Aktivitas",
    placeOfActivity: "Tempat Aktivitas",
    countryOfActivity: "Negara Aktivitas",
    operatorPlaceOfActivity: "Tempat Aktivitas Operator",
    operatorCountryOfActivity: "Negara Aktivitas Operator",
    countryOfEntry: "Negara Masuk",
    productDetail: "Detail Produk",
    subProduct: "Sub-Produk",
    productionDescription: "Deskripsi Produk",
    netMass: "Massa Bersih",
    volume: "Volume",
    scietificName: "Nama Ilmiah",
    commonName: "Nama Umum",
    eudrDueDeligenceReports: "Laporan Kewajiban Hati-hati EUDR",
    EUDRAssessmentReport: "Laporan Penilaian EUDR",
    eudrRefNo: "Nomor Referensi EUDR",
    eudrRefNoInfo:
      "Fungsi untuk menemukan informasi spesifik terkait dengan pengiriman.",
    statusInfo:
      "Status saat ini dari pengiriman terkait dengan laporan uji tuntas.",
    eudrAndInternalRefNo: "Nomor Referensi EUDR / Internal",
    internalRefNo: "Nomor Referensi Internal",
    farmsAndQuantity: "Pertanian & Kuantitas",
    quantity: "Kuantitas",
    product: "Produk",
    lastUpdated: "Terakhir Diperbarui",
    dueDeligenceStatus: "Status Kewajiban Hati-hati",
    edurDueDeligenceStatus: "Status Kewajiban Hati-hati EUDR",
    edurDueDeligenceReport: "Laporan Kewajiban Hati-hati EUDR",
    reject: "Tolak",
    discard: "Buang",
    saveAndContinueLater: "Simpan & Lanjutkan Nanti",
    requestAdditionalInformation: "Minta Informasi Tambahan",
    requestAdditionalInformationShort: "Minta Info Tambahan",
    uploadToEudr: "Unggah ke EUDR",
    productionPlaces: "Tempat Produksi",
    next: "Lanjut",
    dueDeligenceReportCreation: "Pembuatan Laporan Kewajiban Hati-hati",
    producer: "Produsen",
    select: "Pilih",
    productionPlacesFarmAndFarmId:
      "Tempat produksi (Peternakan) & ID peternakan",
    producerName: "Nama Produsen",
    addressOfProduction: "Alamat Produksi",
    geofence: "Pagar Geografis",
    areaHa: "Area (ha)",
    editGeofence: "Edit Pagar Geografis",
    totals: "Total",
    locationVerification: "Verifikasi Lokasi",
    AnalysisOfDeforestationStatus: "Analisis Status Deforestasi",
    EUDRDeforestationStatus: "Status Deforestasi EUDR",
    removeAllLowRiskFarm: "Hapus semua peternakan berisiko rendah",
    removeAllHighRiskFarm: "Hapus semua peternakan berisiko tinggi",
    attachRiskMigrationDoc:
      "Lampirkan satu dokumen mitigasi risiko untuk semua peternakan berisiko tinggi",
    removedFarms: "Peternakan yang dihapus dari daftar",
    generateCertificate: "Hasilkan Sertifikat",
    viewDisputeHistory: "Lihat Riwayat Sengketa",
    reportDetails: "Detail Laporan",
    productionPlace: "Tempat Produksi",
    regionalRiskAssessment: "Penilaian Risiko Regional",
    EUDRDeforestationAssessment: "Penilaian Deforestasi EUDR",
    EUDRcountry:
      "Negara tempat pertanian berada, yang ditautkan ke produk dalam laporan uji tuntas. Ini membantu memastikan ketertelusuran geografis sebagaimana diwajibkan oleh peraturan EUDR.",
    legalInformation: "Informasi Hukum",
    finalReport: "Laporan Akhir",
    editGeolocation: "Edit Geolokasi",
    manuallyAddData: "Tambahkan Data Secara Manual",
    drawGeofence: "Gambar Pagar Geografis",
    uploadFile: "Unggah Berkas",
    typeyourlocation: "Ketik nama/alamat lokasi Anda",
    numberOfPoints: "Jumlah Titik Poligon",
    viewGeolocation: "Lihat Geolokasi",
    geoLocation: "Geolokasi",
    Point: "Titik",
    Circular: "Lingkaran",
    Polygon: "Poligon",
    loadingProductionPlaces: "Memuat Tempat Produksi",
    remove: "Hapus",
    restore: "Pulihkan",
    riskMitigation: "Mitigasi Risiko",
    riskMitigationHistory: "Riwayat Mitigasi Risiko",
    riskMitigationDocument: "Dokumen Mitigasi Risiko",
    signedBy: "Ditandatangani Secara Digital Oleh:",
    signParticipationSurvey:
      "Maukah Anda menandatangani secara digital untuk mengonfirmasi partisipasi Anda dalam survei ini?",
    assessmentRiskMitigation: "Mitigasi Risiko Penilaian",
    submissionDate: "Tanggal Pengiriman",
    eudrReferenceNo: "Nomor Referensi EUDR",
    internalReferenceNo: "Nomor Referensi Internal",
    exporter: "Eksportir",
    exporterInfo:
      "Nama Eksportir. Entitas atau pihak yang bertanggung jawab untuk mengekspor barang.",
    importer: "Importir",
    shipmentReferenceNo: "Nomor Referensi Pengiriman",
    ownerShipType: "Tipe Kepemilikan",
    buyer: "Pembeli",
    buyerName: "Nama Pembeli",
    port_of_origin: "Pelabuhan Asal",
    port_of_origin_info: "Lokasi di mana pengiriman berasal.",
    port_of_destination: "Pelabuhan Tujuan",
    port_of_destination_info:
      "Pelabuhan tujuan yang dimaksud untuk pengiriman.",
    no_of_stops: "Jumlah Pemberhentian",
    shipping_line: "Jalur Pengiriman",
    shipping_line_info:
      "Perusahaan atau entitas yang bertanggung jawab untuk mengangkut pengiriman.",
    expected_arrival_date: "Tanggal Kedatangan yang Diharapkan",
    expected_arrival_date_info:
      "Tanggal perkiraan kedatangan pengiriman di tujuannya.",
    container_id: "ID Kontainer",
    container_id_info:
      "Pengidentifikasi unik untuk kontainer pengiriman yang digunakan dalam pengiriman.",
    container_type: "Tipe Kontainer",
    container_type_info: "Jenis atau kategori kontainer pengiriman.",
    container_size: "Ukuran Kontainer (ft)",
    container_size_info: "Dimensi fisik dari kontainer pengiriman.",
    container_capacity: "Kapasitas Kontainer (Ton)",
    container_capacity_info:
      "Muatan maksimum atau kapasitas kontainer pengiriman.",
    eudr_reference_number: "Nomor Referensi EUDR",
    dueDiligence: "Uji Tuntas EUDR",
    assementBuilder: "Pembuat Penilaian",
    assessment: "Penilaian",
    assessmentsList: "Daftar Penilaian",
    createAssessment: "Buat Penilaian",
    assessmentName: "Nama Penilaian",
    assessmentNameInfo:
      "Fungsi untuk menemukan penilaian atau informasi spesifik.",
    searchAssessment: "Cari Penilaian",
    selectProcess: "Pilih Proses Penilaian",
    assessSettings: "Pengaturan Penilaian",
    assessmentTitle: "Judul Penilaian",
    assessDescription: "Deskripsi Penilaian",
    describeAsessment: "Deskripsikan Penilaian",
    selectCountry: "Pilih Negara",
    expiryTime: "Waktu Kedaluwarsa",
    noQuestionEachStep: "Jumlah Pertanyaan",
    byHeadings: "Menurut Judul",
    assessmentStatus: "Status Penilaian",
    multiStepAssess: "Penilaian Multi Langkah",
    allowAssessment: "Izinkan penilaian dijawab lebih dari sekali",
    onlyIfExpired: "Hanya jika Kedaluwarsa",
    atAnyTime: "Kapan Saja",
    editAssessmentDetails: "Edit Pertanyaan Penilaian",
    assessmentDetail: "Detail Penilaian",
    addQuestion: "Tambah Pertanyaan Penilaian",
    attachFiles: "Lampirkan Berkas",
    digitalSignature: "Tanda Tangan Digital",
    showChecklist: "Tampilkan Daftar Periksa",
    hideChecklist: "Sembunyikan Daftar Periksa",
    fileType: "Tipe Berkas",
    allowMultipleFile: "Izinkan Lampiran Ganda",
    allowComment: "Izinkan Komentar",
    uploadSignatureFile: "Unggah Berkas Tanda Tangan",
    drawSignature: "Gambar Tanda Tangan",
    addSubHeading: "Tambah Sub-judul",
    heading: "Judul",
    subHeading: "Sub-judul",
    dueDiligenceReports: "Laporan Uji Tuntas",
    manageFarms: "Kelola Lahan",
    suppliers: "Pemasok",
    shipments: "Pengiriman",
    dueDiligenceGuide: "Panduan Uji Tuntas",
    selectRequiredAssessment: "Pilih Penilaian yang Dibutuhkan",
    filterAssessments: "Saring Penilaian",
    dueDiligenceReportCreation: "Pembuatan Laporan Uji Tuntas",
    dueDiligenceNew: "Uji Tuntas",
    createNewReport: "Buat Laporan Baru",
    operator: "Operator",
    supplier: "Pemasok",
    addMoreAssessments: "Tambahkan Penilaian Lagi",
    internalReferenceNumber: "Nomor Referensi Internal",
    referenceNumber: "Nomor Referensi",
    domestic: "Domestik",
    import: "Impor",
    export: "Ekspor",
    selectProduct: "Pilih Produk",
    selectSubProduct: "Pilih Sub Produk",
    addnewSupplier: "Tambah Pemasok Baru",
    farmDeforestationReport: "Laporan Deforestasi Lahan",
    addProductionPlaceData: "Tambahkan Data Tempat Produksi",
    addProductionPlaceDataTooltip:
      "Pilih bagaimana Anda ingin menambahkan data",
    addProductionPlaceDataDesc:
      "Buat laporan Anda dengan mengintegrasikan data produksi dari berbagai sumber. Pilih satu atau beberapa sumber untuk menyusun daftar lengkap tempat produksi untuk laporan Anda.",
    dimitraApps: "Aplikasi Dimitra",
    addNew: "Tambah Baru",
    existingData: "Data yang Ada",
    manualDataEntry: "Entri Data Manual",
    importFile: "Impor File",
    connectedCoffee: "Kopi Terhubung",
    connectedCacao: "Kakao Terhubung",
    connectedFarmer: "Petani Terhubung",
    manaulProductionPlace: "Entri Data Tempat Produksi Manual",
    addProductionPlace: "Tambahkan Tempat Produksi",
    producerCountry: "Negara Produsen",
    totalArea: "Luas Total",
    number: "Nomor",
    productionPlaceDesc: "Deskripsi Tempat Produksi",
    type: "Tipe",
    actions: "Aksi",
    selectType: "Pilih Tipe",
    importProductionPlace: "Impor Tempat Produksi",
    downloadCSVFormat: "Unduh Format CSV",
    downloadXLSFormat: "Unduh Format XLS",
    downloadGeoJsonFormat: "Unduh Format GeoJSON",
    downloadXMLFormat: "Unduh Format XML",
    downloadFileFormatTemplates: "Unduh Template Format File",
    importantNote: "Catatan Penting",
    pleaseProvideFollowing: "Silakan berikan format berikut (GeoJSON dan XML)",
    existingProductionPlaces: "Tempat Produksi yang Ada",
    productionPlaceAndFarmID: "Tempat Produksi & ID Peternakan",
    selectFileToUploadData: "Pilih file untuk mengunggah data",
    filterByDate: "Filter Berdasarkan Tanggal",
    dateOfRegister: "Tanggal Pendaftaran",
    dateOfLastReport: "Tanggal Laporan Terakhir",
    clearAll: "Hapus Semua",
    addLocation: "Tambah Lokasi",
    pleaseCompleteBeforeProceedingToNext:
      "Harap selesaikan bagian detail laporan sebelum melanjutkan ke langkah berikutnya.",
    progressSavedSuccessMsg: "Kemajuan berhasil disimpan!",
    failedSavedProgress: "Gagal menyimpan kemajuan. Silakan coba lagi.",
    failedToCreateReportDetails:
      "Gagal membuat ReportDetails. Silakan coba lagi.",
    unExpectedErrorMsg:
      "Terjadi kesalahan yang tidak terduga. Silakan coba lagi.",
    selectAssessment: "Pilih Penilaian",
    confirmationPopup: "Popup Konfirmasi",
    confirmationPopupMsg:
      "Apakah Anda yakin ingin membuang laporan ini? Mengkonfirmasi tindakan ini akan mengakibatkan penghapusan permanen.",
    warningPopup: "Popup Peringatan",
    warningPopupMsg:
      "Apakah Anda yakin ingin menolak laporan ini? Harap dicatat: Data laporan ini akan disimpan setelah penolakan jika Anda ingin meninjaunya nanti.",
    automatedDeforestationProgressText:
      "Pemeriksaan deforestasi otomatis dari data geofence dan identifikasi kasus kritis",
    someRiskWereIdentifiedText:
      "Beberapa risiko diidentifikasi di pertanian berikut, Anda harus meninjau pertanian dengan risiko yang diidentifikasi dan menguranginya sebelum melanjutkan ke langkah berikutnya.",
    riskAssessmentAndMitigation: "Penilaian dan Mitigasi Risiko",
    riskAssessmentStatus: "Status Penilaian Risiko",
    riskAssessment: "Penilaian Risiko",
    uploadRiskAssessment: "Unggah Penilaian Risiko",
    manualFillOutAssessment: "Isi penilaian secara manual",
    manualFillOutAssessmentTT:
      "Tindakan untuk menyelesaikan formulir penilaian secara manual.",
    criteria: "Kriteria (b, f dan g)",
    downloadAssessmentForm: "Unduh Formulir Penilaian",
    addSignature: "Tambahkan Tanda Tangan",
    uploadImage: "Unggah Gambar",
    createNewDueDiligenceProgress: "Buat Proses Due Diligence Baru",
    usageLimits: "Batasan Penggunaan",
    totalReports: "Total Laporan",
    eudrDeforestationAssessments: "Penilaian Deforestasi EUDR",
    totalAssessments: "Total Penilaian",
    listOfFarms: "Daftar Pertanian",
    perMonth: "Per Bulan",
    share: "Bagikan",
    viewReport: "Lihat Laporan",
    listOfSupplier: "Daftar Pemasok",
    addNewSupplier: "Tambahkan pemasok baru",
    editSupplier: "Edit Pemasok",
    supplierName: "Nama Pemasok",
    listOfOperators: "Daftar Operator",
    addNewOperator: "Tambahkan Operator Baru",
    operatorName: "Nama Operator",
    operators: "Operator",
    editOperator: "Edit Operator",
    eoriNumber: "Nomor EORI",
    enterEmailAddress: "Masukkan alamat email",
    enterFirstName: "Masukkan nama depan",
    enterLastName: "Masukkan nama belakang",
    enterEORINumber: "Masukkan Nomor EORI",
    myFarms: "Ladang Saya",
    listOfProducers: "Daftar Produsen",
    producers: "Produsen",
    addNewProducer: "Tambahkan Produsen Baru",
    lastAssessment: "Penilaian Terakhir",
    shipmentID: "ID Pengiriman",
    noOfReports: "Jumlah Laporan",
    operatorSelect:
      "Operator: Pilih opsi ini jika Anda, sebagai operator, akan bertanggung jawab untuk menambahkan data tempat produksi. Anda akan memiliki opsi untuk memberikan daftar produsen, ladang mereka, dan geolokasi dalam aplikasi.",
    supplierSelect:
      "Pemasok: Pilih opsi ini jika pemasok yang akan bertanggung jawab untuk menambahkan data tempat produksi. Mereka akan memiliki akses untuk memberikan daftar produsen, ladang mereka, dan geolokasi langsung dalam aplikasi.",
    selectWhoWillAddPlaceData:
      "Pilih siapa yang akan menambahkan Data Tempat Produksi",
    selectUsers: "Pilih Pengguna",
    mutiStepHeadingLable: "Buat langkah baru untuk setiap Sub-Judul",
    logistics: "Logistik",
    editSubHeading: "Edit Sub-Judul",
    headingTitle: "Judul Utama",
    partOfOrigin: "Bagian Asal",
    destination: "Tujuan",
    addStop: "Tambahkan Pemberhentian",
    stop: "Pemberhentian",
    enterStop: "Masukkan Pemberhentian",
    createShipment: "Buat Pengiriman Baru",
    disputeAssessment: "Penilaian Sengketa",
    multiStepQuestion1: "Buat Langkah Baru setelah",
    questions: "pertanyaan",
    confirmation: "Konfirmasi",
    saveAndConfirmationMessage: "Apakah Anda yakin ingin menyimpan perubahan?",
    supplierNotRegisterContent:
      "Pemasok belum terdaftar. Apakah Anda ingin mengirim pemberitahuan ke pemasok untuk bergabung dengan platform melalui email?",

    farmList: {
      title: "Daftar Peternakan EUDR",
      addFarmGeofenceManually: "Tambahkan geofence peternakan secara manual",
      importGeofenceInBulk: "IMPOR GEOCENCE DALAM JUMLAH BESAR",
      searchPlaceHolder: "Cari berdasarkan nama petani",
      generateCertificate: "Hasilkan Sertifikat",
      requestAssementReport: "Minta Laporan Penilaian",
      producer: "Produser",
      farmNameAndId: "Nama & ID Peternakan",
      addressOfProduction: "Alamat Produksi",
      registrationDate: "Tanggal Registrasi",
      eudrDeforestationStatus: "Status Deforestasi EUDR",
      riskAssessmentStatus: "Status Penilaian Risiko",
      assessmentTitle: "Judul Penilaian",
      assessmentDescription: "Deskripsi Penilaian",
      submissionDate: "Tanggal Pengiriman",
      expiryDate: "Tanggal Kedaluwarsa",
      assessmentStatus: "Status Penilaian",
      downloadAsKmx: "Unduh sebagai KMX",
      downloadAsKml: "Unduh sebagai KML",
      downloadAsShp: "Unduh sebagai SHP",
      downloadAsCsv: "Unduh sebagai CSV",
      downloadAsExcel: "Unduh sebagai EXCEL",
      downloadAsPdf: "Unduh sebagai PDF",
      downloadAsGeoJson: "Unduh sebagai GeoJSON",
      loadingFarms: "Memuat peternakan",
    },
    dueDeligenceReport: "Konfigurasi Laporan Uji Tuntas Publik",
    allowPublicDownload:
      "Izinkan unduhan publik geofence pertanian dalam format GeoJson",
    showDeforestationSummary:
      "Tampilkan Ringkasan Risiko Deforestasi EUDR berdasarkan kategori",
    cancel: "Batalkan",

    deforestationAssessmentRiskToleranceLevel:
      "Tingkat Toleransi Risiko Penilaian Deforestasi",
    deforestationAssessmentRiskToleranceLevelInfo:
      "Gunakan alat ini untuk mengonfigurasi berapa % deforestasi, untuk setiap peringkat, yang dapat diterima dalam proses Penilaian Risiko Anda. Peternakan dengan risiko kurang dari atau sama dengan yang ditentukan akan dianggap layak untuk tetap berada di DDS, tanpa perlu melakukan Mitigasi Risiko.",
    showing_all: "Menampilkan Semua",
    declaration_title: "Judul Deklarasi",
    applicable_countries: "Negara yang Berlaku",
    enabled: "Diaktifkan",
    disabled: "Dinonaktifkan",
    add_more: "Buyer Lagi",
    mark_as_default: "Tandai sebagai Default",
    print: "Cetak",
    download: "Unduh",
    loading: "Memuat...",
    tons: "Ton",

    failedToDeleteQuestion: "Gagal menghapus pertanyaan",
    questionTypeNotDefined: "Jenis pertanyaan belum ditentukan",
    questionOrderSuccessfullyUpdated: "Urutan pertanyaan berhasil diperbarui",
    assessmentUpdatedSuccessfully: "Penilaian berhasil diperbarui",
    pleaseWaitCurrentlyUpdatingChecklist:
      "Harap tunggu, sedang memperbarui daftar periksa",

    assessmentDetails: "Detail Penilaian",
    dontShowWarning: "Jangan tampilkan peringatan ini lagi.",
    dateSubmitted: "Tanggal Dikirim",
    addAComment: "Tambahkan Komentar",
    changeAssignee: "Ubah Penanggung Jawab",
    changeStatus: "Ubah Status",
    assignedUser: "Pengguna yang Ditugaskan",
    selectAssignee: "Pilih Penanggung Jawab",
    reply: "Balas",
    discussion: "Diskusi",
    attachment: "Lampiran",
    sizeKb: "Ukuran (KB)",
    dateAdded: "Tanggal Ditambahkan",

    shipmentStatus: "Status Pengiriman",
    viewStops: "Lihat Pemberhentian",
    enRoute: "Dalam Perjalanan",
    delivered: "Terkirim",
    failed: "Gagal",
    removeEudrDeforestationStatus: "Hapus Status Deforestasi EUDR",
    riskAssessmentStatusIsRequired: "Status penilaian risiko diperlukan",
    requestAdditionalInformationPage: {
      descriptionLabel: "Harap berikan komentar atau instruksi spesifik di kotak teks di bawah ini. Setelah dikirim, pemasok akan diberi tahu dan diberikan akses untuk mengedit laporan due diligence. Anda akan diberi tahu ketika pemasok memperbarui laporan.",
      shareAccessLabel: "Pemasok saat ini tidak memiliki akses ke laporan ini. Apakah Anda ingin membagikan akses dengan pemasok? Silakan pilih bagaimana Anda ingin berbagi akses:",
      shareCompleteReportLabel: "Bagikan laporan lengkap",
      shareSpecificStepLabel: "Bagikan langkah tertentu"
    },
    issueFound: "Masalah Ditemukan",
    complianceRiskWarningsTT: "Pemberitahuan Peringatan Risiko memberi tahu Anda tentang potensi masalah kepatuhan di setiap langkah proses due diligence. Pemberitahuan ini membantu memastikan bahwa semua risiko teridentifikasi sebelum melanjutkan ke tahap berikutnya. Anda dapat mengaktifkan atau menonaktifkan peringatan ini kapan saja di Pengaturan Laporan atau selama pembuatan laporan.",
  },
  dueDiligence: {
    comments: "Komentar",
    commentsRegardingStatement:"komentar mengenai pernyataan",
    countryOfProduction: "Negara Produksi",
    countryOfProductionTT: "Negara Produksi",
    containerId:"Id Kontainer",
    createWithoutRiskAssessment: {
      title: "Buat DDS Tanpa Penilaian Risiko",
      message: "Apakah Anda ingin membuat DDS tanpa menambahkan Penilaian Risiko? Jika ya, aturan pemeriksaan keluhan akan melewati langkah ini.",
      confirmBtnText: "Ya",
      cancelBtnText: "Tidak"
    },
    noAssessmentWarning: "Laporan DDS tidak memiliki penilaian risiko.",
    disputeReason: "Silakan pilih alasan perselisihan.",
    agricultureAgreement: "Silakan setujui ketentuan sebelum melanjutkan.",
    attachDisputeFile:
      "Silakan lampirkan file sebelum mengajukan perselisihan.",
    listOfFarmsInfo:
      "Tampilan pertanian yang komprehensif, termasuk informasi seperti lokasi produksi, nama produsen, negara operasi, luas lahan dalam hektar, jenis kegiatan pertanian, penilaian terkait deforestasi, dan evaluasi potensi risiko yang terkait dengan operasi pertanian.",
    producerTT:
      "Pemilihan produsen atau pembuat yang terlibat dalam rantai pasokan.",
    supplierInformationTT:
      "Rincian tentang entitas yang menyediakan barang atau jasa.",
    operatorTooltip:
      "Pilih Operator dari daftar yang sudah terdaftar di sistem",
    supplierTooltip:
      "Pilih pemasok dari daftar yang telah terdaftar sebelumnya di sistem.",
    requiredAssessmentTooltip: "Pilih informasi penilaian yang diperlukan.",
    internalRefNoTooltip:
      "Pengidentifikasi unik yang ditetapkan dalam suatu organisasi atau sistem untuk merujuk pada data, transaksi, atau catatan tertentu untuk tujuan pelacakan dan pengelolaan internal.",
    eudrRefNoTooltip:
      "Mengacu pada pengidentifikasi unik yang terkait dengan Regulasi Penggundulan Hutan Uni Eropa (EUDR), biasanya digunakan untuk melacak dan merujuk informasi terkait kepatuhan dalam konteks regulasi penggundulan hutan.",
    companyIdTooltip:
      "Pengidentifikasi yang berbeda yang diberikan kepada perusahaan atau organisasi untuk tujuan identifikasi dan pelacakan, sering digunakan dalam sistem, basis data, atau kerangka peraturan.",
    placeOfActivityTooltip: "Tentukan negara operator tempat aktivitas dilakukan dan negara tempat produk akan memasuki pasar UE. Detail ini penting untuk kepatuhan yang akurat dengan persyaratan EUDR.",
    productDetailToolTip:
      "Memberikan informasi rinci tentang produk, termasuk nama, massa bersih, volume, nama ilmiah, dan nama umum.",
    productToolTip:
      "Nama Produk. Mengacu pada item atau barang berwujud yang diproduksi, dibuat, atau diperdagangkan oleh perusahaan.",
    productDescToolTip:
      "Memberikan penjelasan atau ringkasan tekstual tentang karakteristik, fungsi, atau atribut suatu produk, dengan tujuan untuk menginformasikan pengguna atau pelanggan tentang sifat atau fungsinya.",
    subProductToolTip:
      "Nama Sub-produk. Menunjukkan kategori atau sub-kategori spesifik dari kategori produk yang lebih besar, biasanya digunakan untuk klasifikasi atau diferensiasi tambahan dalam hierarki produk.",
    netMassTooltTip:
      "Menunjukkan berat suatu produk atau item, biasanya tidak termasuk berat kemasan atau bahan lainnya.",
    volumeToolTip:
      "Mengacu pada jumlah ruang yang ditempati oleh produk atau zat, biasanya diukur dalam satuan kubik seperti meter kubik atau kaki kubik, digunakan untuk mengukur kapasitas atau jumlah dalam ruang tiga dimensi.",
    scientificNameToolTip:
      "Nama taksonomi dari suatu organisme yang terdiri dari genus dan spesies, misalnya, Coffea Arabica, Theobroma cacao L.",
    commonNameToolTip:
      "Nama berdasarkan bahasa sehari-hari, misalnya, Kakao, Kopi.",
    manualProductionPlaceTooltip:
      "Proses memasukkan lokasi pabrik secara manual ke dalam sistem.",
    producerNameTT:
      "Nama individu/perusahaan/organisasi yang menciptakan dan menyediakan barang atau jasa.",
    producerCountryTT: "Negara asal dari produsen.",
    dueDiligence: "Uji Tuntas EUDR",
    assementBuilder: "Pembuat Penilaian",
    assessment: "Penilaian",
    assessmentsList: "Daftar Penilaian",
    createAssessment: "Buat Penilaian",
    assessmentName: "Nama Penilaian",
    searchAssessment: "Cari Penilaian",
    selectProcess: "Pilih Proses Penilaian",
    assessSettings: "Pengaturan Penilaian",
    assessmentTitle: "Judul Penilaian",
    assessmentTitleInfo: "Nama yang mengidentifikasi penilaian.",
    assessDescription: "Deskripsi Penilaian",
    assessDescriptionInfo:
      "Penjelasan singkat tentang tujuan atau isi penilaian.",
    describeAsessment: "Deskripsikan Penilaian",
    selectCountry: "Pilih Negara",
    expiryTime: "Waktu Kedaluwarsa",
    expiryTimeInfo:
      "Durasi hingga penilaian kedaluwarsa atau menjadi tidak berlaku.",
    noQuestionEachStep: "Jumlah Pertanyaan",
    byHeadings: "Menurut Judul",
    assessmentStatus: "Status Penilaian",
    multiStepAssess: "Penilaian Multi Langkah",
    allowAssessment: "Izinkan penilaian dijawab lebih dari sekali",
    onlyIfExpired: "Hanya jika Kedaluwarsa",
    atAnyTime: "Kapan Saja",
    editAssessmentDetails: "Edit Pertanyaan Penilaian",
    assessmentDetail: "Detail Penilaian",
    addQuestion: "Tambah Pertanyaan Penilaian",
    attachFiles: "Lampirkan Berkas",
    digitalSignature: "Tanda Tangan Digital",
    showChecklist: "Tampilkan Daftar Periksa",
    hideChecklist: "Sembunyikan Daftar Periksa",
    fileType: "Tipe Berkas",
    allowMultipleFile: "Izinkan Lampiran Ganda",
    allowComment: "Izinkan Komentar",
    uploadSignatureFile: "Unggah Berkas Tanda Tangan",
    drawSignature: "Gambar Tanda Tangan",
    addSubHeading: "Tambah Sub-judul",
    heading: "Judul",
    headingInfo:
      "Judul di mana pertanyaan penilaian akan dikategorikan. Menu dropdown untuk memilih judul.",
    subHeading: "Sub-judul",
    dueDiligenceReports: "Laporan Uji Tuntas",
    manageFarms: "Kelola Lahan",
    disputeResolution: "Penyelesaian Sengketa",
    suppliers: "Pemasok",
    shipments: "Pengiriman",
    dueDiligenceGuide: "Panduan Uji Tuntas",
    selectRequiredAssessment: "Pilih Penilaian yang Dibutuhkan",
    filterAssessments: "Saring Penilaian",
    dueDiligenceReportCreation: "Pembuatan Laporan Uji Tuntas",
    dueDiligenceNew: "Uji Tuntas",
    createNewReport: "Buat Laporan Baru",
    operator: "Operator",
    supplier: "Pemasok",
    addMoreAssessments: "Tambahkan Penilaian Lagi",
    internalReferenceNumber: "Nomor Referensi Internal",
    referenceNumber: "Nomor Referensi",
    domestic: "Domestik",
    import: "Impor",
    export: "Ekspor",
    selectProduct: "Pilih Produk",
    selectSubProduct: "Pilih Sub Produk",
    addnewSupplier: "Tambah Pemasok Baru",
    farmDeforestationReport: "Laporan Deforestasi Lahan",
    addProductionPlaceData: "Tambahkan Data Tempat Produksi",
    addProductionPlaceDataTooltip:
      "Pilih bagaimana Anda ingin menambahkan data",
    addProductionPlaceDataDesc:
      "Buat laporan Anda dengan mengintegrasikan data produksi dari berbagai sumber. Pilih satu atau beberapa sumber untuk menyusun daftar lengkap tempat produksi untuk laporan Anda.",
    dimitraApps: "Aplikasi Dimitra",
    addNew: "Tambah Baru",
    existingData: "Data yang Ada",
    manualDataEntry: "Entri Data Manual",
    importFile: "Impor File",
    connectedCoffee: "Kopi Terhubung",
    connectedCacao: "Kakao Terhubung",
    manaulProductionPlace: "Entri Data Tempat Produksi Manual",
    manaulProductionPlaceTooltip:
      "Proses memasukkan lokasi pabrik secara manual ke dalam sistem.",
    addProductionPlace: "Tambahkan Tempat Produksi",
    producerName: "Nama Produsen",
    producerCountry: "Negara Produsen",
    totalArea: "Luas Total",
    number: "Nomor",
    productionPlaceDesc: "Deskripsi Tempat Produksi",
    area: "Area (ha)",
    type: "Tipe",
    actions: "Aksi",
    selectType: "Pilih Tipe",
    importProductionPlace: "Impor Tempat Produksi",
    downloadXLSFormat: "Unduh Format XLS",
    downloadGeoJsonFormat: "Unduh Format GeoJSON",
    downloadXMLFormat: "Unduh Format XML",
    downloadFileFormatTemplates: "Unduh Template Format File",
    importantNote: "Catatan Penting",
    pleaseProvideFollowing: "Silakan berikan format berikut (GeoJSON dan XML)",
    existingProductionPlaces: "Tempat Produksi yang Ada",
    productionPlaceAndFarmID: "Tempat Produksi & ID Peternakan",
    selectFileToUploadData: "Pilih file untuk mengunggah data",
    filterByDate: "Filter Berdasarkan Tanggal",
    dateOfRegister: "Tanggal Pendaftaran",
    dateOfLastReport: "Tanggal Laporan Terakhir",
    clearAll: "Hapus Semua",
    addLocation: "Tambah Lokasi",
    pleaseCompleteBeforeProceedingToNext:
      "Harap selesaikan bagian detail laporan sebelum melanjutkan ke langkah berikutnya.",
    progressSavedSuccessMsg: "Kemajuan berhasil disimpan!",
    failedSavedProgress: "Gagal menyimpan kemajuan. Silakan coba lagi.",
    failedToCreateReportDetails:
      "Gagal membuat ReportDetails. Silakan coba lagi.",
    unExpectedErrorMsg:
      "Terjadi kesalahan yang tidak terduga. Silakan coba lagi.",
    selectAssessment: "Pilih Penilaian",
    confirmationPopup: "Popup Konfirmasi",
    confirmationPopupMsg:
      "Apakah Anda yakin ingin membuang laporan ini? Mengkonfirmasi tindakan ini akan mengakibatkan penghapusan permanen.",
    warningPopup: "Popup Peringatan",
    warningPopupMsg:
      "Apakah Anda yakin ingin menolak laporan ini? Harap dicatat: Data laporan ini akan disimpan setelah penolakan jika Anda ingin meninjaunya nanti.",
    automatedDeforestationProgressText:
      "Pemeriksaan deforestasi otomatis dari data geofence dan identifikasi kasus kritis",
    someRiskWereIdentifiedText:
      "Beberapa risiko diidentifikasi di pertanian berikut, Anda harus meninjau pertanian dengan risiko yang diidentifikasi dan menguranginya sebelum melanjutkan ke langkah berikutnya.",
    riskAssessmentAndMitigation: "Penilaian dan Mitigasi Risiko",
    riskAssessmentStatus: "Status Penilaian Risiko",
    riskAssessment: "Penilaian Risiko",
    uploadRiskAssessment: "Unggah Penilaian Risiko",
    uploadRiskAssessmentTT:
      "Tindakan untuk mengunggah dokumen penilaian risiko.",
    manualFillOutAssessment: "Isi penilaian secara manual",
    downloadAssessmentForm: "Unduh Formulir Penilaian",
    addSignature: "Tambahkan Tanda Tangan",
    createNewDueDiligenceProgress: "Buat Proses Due Diligence Baru",
    usageLimits: "Batasan Penggunaan",
    totalReports: "Total Laporan",
    eudrDeforestationAssessments: "Penilaian Deforestasi EUDR",
    totalAssessments: "Total Penilaian",
    listOfFarms: "Daftar Pertanian",
    perMonth: "Per Bulan",
    share: "Bagikan",
    viewReport: "Lihat Laporan",
    viewReportSummary: "Lihat Ringkasan Laporan",
    copy: "Salin",
    copyAndCreateNew: "Salin dan Buat Baru",
    listOfSupplier: "Daftar Pemasok",
    addNewSupplier: "Tambahkan pemasok baru",
    editSupplier: "Edit Pemasok",
    supplierName: "Nama Pemasok",
    listOfOperators: "Daftar Operator",
    addNewOperator: "Tambahkan Operator Baru",
    operatorName: "Nama Operator",
    operators: "Operator",
    editOperator: "Edit Operator",
    eoriNumber: "Nomor EORI",
    isoCode: "Kode ISO",
    enterEmailAddress: "Masukkan alamat email",
    enterFirstName: "Masukkan nama depan",
    enterLastName: "Masukkan nama belakang",
    enterEORINumber: "Masukkan Nomor EORI",
    myFarms: "Ladang Saya",
    listOfProducers: "Daftar Produsen",
    producers: "Produsen",
    addNewProducer: "Tambahkan Produsen Baru",
    lastAssessment: "Penilaian Terakhir",
    noOfFarms: "Jumlah Ladang",
    shipmentID: "ID Pengiriman",
    noOfReports: "Jumlah Laporan",
    operatorSelect:
      "Operator: Pilih opsi ini jika Anda, sebagai operator, akan bertanggung jawab untuk menambahkan data tempat produksi. Anda akan memiliki opsi untuk memberikan daftar produsen, ladang mereka, dan geolokasi dalam aplikasi.",
    supplierSelect:
      "Pemasok: Pilih opsi ini jika pemasok yang akan bertanggung jawab untuk menambahkan data tempat produksi. Mereka akan memiliki akses untuk memberikan daftar produsen, ladang mereka, dan geolokasi langsung dalam aplikasi.",
    selectWhoWillAddPlaceData:
      "Pilih siapa yang akan menambahkan Data Tempat Produksi",
    selectUsers: "Pilih Pengguna",
    country: "Negara",
    mutiStepHeadingLable: "Buat langkah baru untuk setiap Sub-Judul",
    logistics: "Logistik",
    editSubHeading: "Edit Sub-Judul",
    headingTitle: "Judul Utama",
    partOfOrigin: "Bagian Asal",
    destination: "Tujuan",
    addStop: "Tambahkan Pemberhentian",
    stop: "Pemberhentian",
    enterStop: "Masukkan Pemberhentian",
    shipmentList: "Daftar Pengiriman",
    createShipment: "Buat Pengiriman Baru",
    disputeAssessment: "Penilaian Sengketa",
    multiStepQuestion1: "Buat Langkah Baru setelah",
    questions: "pertanyaan",
    questionsInfo: "Jumlah pertanyaan di setiap tahap penilaian bertahap.",
    confirmation: "Konfirmasi",
    saveAndConfirmationMessage: "Apakah Anda yakin ingin menyimpan perubahan?",
    supplierNotRegisterContent:
      "Pemasok belum terdaftar. Apakah Anda ingin mengirim pemberitahuan ke pemasok untuk bergabung dengan platform melalui email?",
    downloadAsJSON: "Unduh sebagai JSON",
    downloadOptions: "Opsi Unduhan",
    supplierTT:
      "Pemilihan pemasok atau produsen yang terlibat dalam rantai pasokan.",
    pleaseSelectAtLeastOneItem: "Harap pilih setidaknya satu item.",

    pleaseSelectAtLeastOneSource: "Silakan pilih setidaknya satu sumber.",
    invalidFileFormatPleaseUploadValidFile:
      "Format file tidak valid. Silakan unggah file .xml, .kml, atau .geojson.",
    pleaseUploadAValidFile: "Silakan unggah file yang valid.",
    fileUploadedDuccessfully: "File berhasil diunggah!",
    anErrorOccured: "Terjadi kesalahan.",
    successfullyUpdatedDefaultFarmArea:
      "Area pertanian default berhasil diperbarui.",
    pleaseAddProductionPlacesData: "Silakan tambahkan data Tempat Produksi.",
    failedToFetchSettings: "Gagal mengambil pengaturan.",
    updatedDueDiligenceReport: "Laporan due diligence diperbarui.",
    updatedDueDiligenceStatus:
      "Status Uji Tuntas telah diperbarui dengan sukses.",
    failedToWriteDeforestationDataToBlockchain:
      "Gagal menulis data deforestasi ke blockchain, silakan coba lagi.",
    countryIsRequired: "Negara diperlukan",
    dueDiligenceReportsInfo:
      "Dokumentasi rinci yang merangkum temuan dan hasil dari proses uji tuntas. Laporan ini memberikan wawasan tentang penilaian yang dilakukan, termasuk risiko apa pun yang diidentifikasi, status kepatuhan, dan rekomendasi untuk mitigasi atau perbaikan.",
    listOfFarmsTT:
      "Tampilan komprehensif dari ladang, termasuk informasi seperti lokasi produksi, nama produsen, negara operasi, luas lahan dalam hektar, jenis kegiatan pertanian, penilaian terkait deforestasi, dan evaluasi risiko potensial yang terkait dengan operasi ladang.",
    loadingPleaseWait: "Memuat... Mohon tunggu",
    existingProductionPlacesTT:
      "Menampilkan daftar tempat produksi yang ada beserta detail seperti nama produsen, negara, area, jenis, dan status penilaian.",
    successfullyGeneratedEUDRDeforestationStatus:
      "Status deforestasi EUDR berhasil dihasilkan.",
    riskAssessmentAndMitigationTT:
      "Mengidentifikasi risiko potensial dan menerapkan strategi untuk meminimalkan dampaknya atau kemungkinan terjadinya. Ini mencakup mengevaluasi bahaya, menganalisis konsekuensi potensialnya, dan mengembangkan rencana untuk mengatasinya atau menguranginya secara efektif.",
    eudrRefNoTT:
      "Pengenal unik yang diberikan untuk setiap laporan uji tuntas, memfasilitasi pelacakan dan verifikasi kepatuhan dalam kerangka Regulasi Deforestasi Uni Eropa (EUDR).",

    operatorData: "Data Operator",
    supplierData: "Data Pemasok",
    supplierDataTT: "Informasi tentang pemasok.",
    operatorDataTT: "Informasi tentang operator.",
    reportSummary: "Ringkasan Risiko",
    reportSummaryTT: "Ikhtisar singkat laporan.",
    totalNoOfGeofencePolygon: "Jumlah Total Poligon Geofence",
    totalNoOfGeofencePolygonTT: "Jumlah total poligon geofence.",
    totalNoOfGeofencePoint: "Jumlah Total Titik Geofence",
    totalNoOfGeofencePointTT: "Jumlah total titik geofence.",
    totalNoOfFarms: "Jumlah Total Peternakan",
    totalNoOfFarmsTT: "Jumlah total peternakan.",
    totalAreaFinalReport: "Total Luas (ha)",
    totalNoOfDeforestation: "Jumlah Total Deforestasi",
    totalNoOfDeforestationTT: "Jumlah total penilaian deforestasi.",
    totalNoOfHighDeforestation: "Jumlah Total Deforestasi Tinggi",
    totalNoOfHighDeforestationTT:
      "Jumlah total peternakan dengan deforestasi tinggi.",
    totalNoOfRiskAssessments: "Jumlah Total Penilaian Risiko",
    totalNoOfRiskAssessmentsTT: "Jumlah total penilaian risiko.",
    productDetail: "Detail Produk",
    productDetailTT: "Informasi tentang produk.",
    product: "Produk",
    productTT:
      "Nama produk. Mengacu pada barang nyata atau komoditas yang diproduksi, diproduksi, atau diperdagangkan oleh perusahaan atau organisasi, sering kali dikategorikan berdasarkan jenis, karakteristik, atau tujuan.",
    productDescription: "Deskripsi Produk",
    productDescriptionTT:
      "Memberikan penjelasan atau ringkasan tertulis tentang karakteristik, fitur, atau atribut suatu produk, bertujuan untuk memberi informasi kepada pengguna atau pelanggan tentang sifat atau fungsinya.",
    netMass: "Massa Bersih",
    netMassTT:
      "Menunjukkan berat suatu produk atau barang, biasanya tidak termasuk berat kemasan atau bahan terkait lainnya, sering kali dinyatakan dalam satuan massa seperti kilogram atau pon.",
    volume: "Volume",
    volumeTT:
      "Mengacu pada jumlah ruang yang ditempati oleh produk atau zat, biasanya diukur dalam satuan kubik seperti meter kubik atau kaki kubik, digunakan untuk mengukur kapasitas atau kuantitas dalam ruang tiga dimensi.",
    scientificName: "Nama Ilmiah",
    scientificNameTT:
      "Nama taksonomi suatu organisme yang terdiri dari genus dan spesies, misalnya Coffea Arabica, Theobroma cacao L.",
    commonNameTT:
      "Nama yang didasarkan pada bahasa normal kehidupan sehari-hari mis. Kakao, Kopi.",

    declarationStatement: "Pernyataan Deklarasi",
    complianceRiskWarning: "Peringatan Risiko Kepatuhan",
    successfullyUploadedToTheBlockchain:
      "Berhasil! Laporan Due Diligence EUDR telah berhasil diunggah ke Blockchain.",
    issueIdentifiedOnFarms:
      "Masalah telah diidentifikasi di beberapa pertanian yang memerlukan perhatian sebelum melanjutkan ke langkah berikutnya. Anda dapat memilih untuk menangani masalah ini sekarang atau melanjutkan ke langkah berikutnya dan menyelesaikannya nanti.",
    blockchainDescs: [
      "Mengunggah laporan ke blockchain, harap tunggu...",
      "Laporan Due Diligence Anda sedang diunggah ke blockchain. Anda akan diarahkan ke halaman daftar Laporan Due Diligence untuk melihat statusnya.",
    ],
    reportDownloadedSuccessfully: "Laporan berhasil diunduh!",
    operatorDecleration: "Pernyataan Operator",
    supplierDecleration: "Pernyataan Pemasok",
    internalReferenceNumberTT:
      "Nomor referensi internal adalah pengenal unik yang diberikan kepada laporan due diligence di dalam sistem.",
    fRinternalReferenceNumberTT:
      "Nomor referensi internal adalah pengenal unik yang diberikan kepada laporan due diligence di dalam sistem.",
    deleteProductionPlaceData: "Hapus Data Tempat Produksi",
    areYouSureYouWantToContinueThisAction:
      "Apakah Anda yakin ingin melanjutkan tindakan ini?",
    noAssessment: "Nessuna Valutazione",

    analyzingStatus: "Menganalisis Status Deforestasi",
    analyzingDesc:
      "Ladang Anda sedang dianalisis secara otomatis untuk deforestasi. Anda akan diarahkan ke halaman daftar laporan due diligence untuk melihat statusnya.",
    readyToProceed: "Siap untuk Melanjutkan",
    mitigationRequired: "Mitigasi Diperlukan",
    viewSummary: "Lihat Ringkasan",
    viewAssessment: "Lihat Penilaian",
    disputes: "Perselisihan",
    manualRiskMitigation: "Mitigasi Risiko Manual",
    veryHighProbability: "Kemungkinan Sangat Tinggi",
    highProbability: "Kemungkinan Tinggi",
    mediumProbability: "Kemungkinan Sedang",
    lowProbability: "Kemungkinan Rendah",
    veryLowProbability: "Kemungkinan Sangat Rendah",
    zeroProbability: "Kemungkinan Nol/Nyaris Nol",
    manualMitigated: "Dimitigasi Secara Manual",
    disputeDesc:
      "Klik salah satu perselisihan di bawah untuk melihat detail lebih lanjut.",
    geofenceColorCode: "Kode Warna Geofence:",
    noDisputeHaveSubmitted: "Belum ada perselisihan yang diajukan",
    disputeDetails: "Detail Perselisihan",
    chooseDisputeReason: "Pilih Alasan Perselisihan",
    pleaseAttachDoc:
      "Silakan lampirkan dokumen/foto untuk mendukung jawaban Anda.",
    additionalNotes: "Catatan Tambahan",
    aggrementStatement:
      "Saya mengerti bahwa tanah yang terpengaruh tidak akan digunakan untuk pertanian dalam beberapa tahun mendatang.",
    addGeofenceRadius: "Tambahkan Radius Geofence",
    totalGeofenceRadius: "Total Radius Geofence adalah",
    resolutionHistory: "Sejarah Penyelesaian",
    proceed: "Lanjutkan",
    wildFire: "Kebakaran Hutan",
    controlledFire: "Kebakaran Terkendali",
    clearingForAgriculture: "Pembersihan untuk Pertanian dan/atau Peternakan",
    pestAndDiseases: "Hama dan Penyakit",
    naturalChangesInCanopy:
      "Perubahan Alam pada Kanopi (seperti guguran daun musiman)",
    strongWinds: "Angin Kuat (seperti angin topan atau tornado)",
    otherNaturalDisasters: "Bencana Alam Lainnya",
    flooding: "Banjir",
    logging: "Penebangan Hutan",
    infrastructure: "Infrastruktur",
    urbanization: "Urbanisasi",
    landGrabbingOrPopulationPressure:
      "Penguasaan Tanah, Pertanian Subsisten, atau Tekanan Populasi",
    mining: "Pertambangan",
    plantationForestBeforeDeadline:
      "Ini adalah hutan tanaman atau tanah berhutan, tetapi hutan primer atau hutan yang pulih secara alami diubah menjadi hutan tanaman atau tanah berhutan lainnya sebelum batas waktu (31 Desember 2020)",
    convertedToPlantationForest:
      "Hutan primer atau hutan yang pulih secara alami diubah menjadi hutan tanaman atau tanah berhutan lainnya",
    cultivatedAreaBeforeDeadline:
      "Ini adalah area yang dibudidayakan dan tidak mengalami deforestasi setelah batas waktu (31 Desember 2020)",
    forestStillPreserved:
      "Masih ada hutan di area tersebut, tetapi tidak mengalami deforestasi dan masih terjaga",
    downloadAsPDF: "Unduh sebagai PDF",
    productionPlacesHighDeforestationProbability:
      "Tempat produksi memiliki kemungkinan tinggi untuk deforestasi",
    geofenceHighDeforestationProbability:
      "Geofence memiliki kemungkinan tinggi untuk deforestasi",
    EUDRReferenceNumber: "Nomor Referensi EUDR",
    commonName: "Nama Umum",
    totalNoOfRiskAssessment: "Jumlah Total Penilaian Risiko",
    totalNoOFDeforestationAssessments: "Jumlah Total Penilaian Deforestasi",
    totalNoOfGeofencePoints: "Jumlah Total Titik Geofence",
    totalNoOfGeofencePolygons: "Jumlah Total Poligon Geofence",
    dueDiligenceReportStatus: "Status Laporan Due Diligence",
    undoDelete: "Batalkan Penghapusan",
    analyzingDeforestation: "Menganalisis Deforestasi",
    processingFarm: "Memproses Pertanian",

    uploadingToBlockchain: "Mengunggah laporan ke blockchain, harap tunggu...",
    beingUploadToBlockChain:
      "Laporan Due Diligence Anda sedang diunggah ke blockchain. Anda akan diarahkan ke halaman daftar Laporan Due Diligence untuk melihat statusnya.",
    uploading: "Mengunggah",
    attachFile: "Lampirkan Berkas",
    close: "Tutup",
    status: "Status",
    lotID: "ID Lot",
    noOfFarm: "Jumlah Kebun",
    processingDate: "Tanggal Pemrosesan",
    origin: "Asal",
    selectUsingLots: "Pilih Lokasi Produksi Menggunakan Lot",
    productionPlaceUsingFarms: "Pilih Lokasi Produksi Menggunakan Kebun",
    searchFarmName: "Cari nama kebun",
    viewLocation: "Lihat Geolokasi",
    netMassKG: "Massa Bersih (kg)",
    volumeM3: "Volume (m³)",
    areaInHA: "Luas (ha)",
    eudrUploadedToBlockChain:
      "Sukses! Laporan Due Diligence EUDR telah berhasil diunggah ke Blockchain.",
    viewDeforestationAssessment: "Lihat Penilaian Deforestasi",
    viewDeforestationCertificate: "Lihat Sertifikat Deforestasi",
    selectCountries: "Pilih Negara",
    writingToBlockchain: "Menulis ke Blockchain",

    cattle: "Sapi",
    cocoa: "Kakao",
    coffee: "Kopi",
    wood: "Kayu",
    soya: "Kedelai",
    rubber: "Karet",
    oilPlam: "Minyak sawit",

    subProduct1: "0102 21 , 0102 29 Sapi hidup",
    subProduct2: "0201 Daging sapi, segar atau dingin",
    subProduct3: "0202 Daging sapi, beku",
    subProduct4: "0206 10 Jeroan sapi yang dapat dimakan, segar atau dingin",
    subProduct5: "0206 22 Hati sapi yang dapat dimakan, beku",
    subProduct6:
      "0206 29 Jeroan sapi yang dapat dimakan (tidak termasuk lidah dan hati), dibekukan",
    subProduct7:
      "1602 50 Daging, sisa daging, darah, sapi olahan atau diawetkan lainnya",
    subProduct8:
      "4101 Kulit dan kulit sapi mentah (segar, atau diasinkan, dikeringkan, dikapur, diasamkan atau diawetkan secara lain, tetapi tidak disamak, tidak diolah secara perkamen atau diolah lebih lanjut), dihilangkan bulunya atau dibelah maupun tidak",
    subProduct9:
      "4104 Kulit dan kulit sapi yang disamak atau berkerak, tanpa bulu, dibelah maupun tidak, tetapi tidak diolah lebih lanjut",
    subProduct10:
      "4107 Kulit sapi, diolah lebih lanjut setelah penyamakan atau pengerasan kulit, termasuk kulit yang diolah secara perkamen, tanpa bulu, dibelah maupun tidak, selain kulit samak dari pos 41.14",
    subProduct11: "1801 Biji kakao, utuh atau pecah, mentah atau dipanggang",
    subProduct12: "1802 Cangkang kakao, sekam, kulit dan sisa kakao lainnya",
    subProduct13: "1803 Pasta kakao, dihilangkan lemaknya maupun tidak",
    subProduct14: "1804 Mentega kakao, lemak dan minyak",
    subProduct15:
      "1805 Kakao bubuk, tidak mengandung tambahan gula atau bahan pemanis lainnya",
    subProduct16: "1806 Coklat dan olahan makanan lain yang mengandung kakao",
    subProduct17:
      "0901 Kopi, digongseng atau dihilangkan kafeinnya maupun tidak; sekam dan kulit kopi; pengganti kopi yang mengandung kopi dalam proporsi berapa pun",
    subProduct18: "1207 10 Kacang dan inti sawit",
    subProduct19:
      "1511 Minyak kelapa sawit dan fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia",
    subProduct20:
      "1513 21 Inti sawit mentah dan minyak babassu serta fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia",
    subProduct21:
      "1513 29 Minyak inti sawit dan babassu serta fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia (tidak termasuk minyak mentah)",
    subProduct22:
      "2306 60 Bungkil minyak dan residu padat lainnya dari kacang atau inti sawit, digiling atau dalam bentuk pelet maupun tidak, hasil ekstraksi lemak atau minyak dari kacang atau kernel",
    subProduct23:
      "2905 45 Gliserol, dengan kemurnian 95 % atau lebih (dihitung berdasarkan berat produk kering)",
    subProduct24: "2915 70 Asam palmitat, asam stearat, garam dan esternya",
    subProduct25:
      "2915 90 Asam monokarboksilat asiklik jenuh, anhidrida, halida, peroksida dan asam peroksinya; turunan halogenasi, sulfonasi, nitrasi atau nitrosasinya (tidak termasuk asam format, asam asetat, asam mono-, di- atau trikloroasetat, asam propionat, asam butanoat, asam pentanoat, asam palmitat, asam stearat, garam dan esternya, dan anhidrida asetat)",
    subProduct26: "3823 11 Asam stearat, industri",
    subProduct27: "3823 12 Asam oleat, industri",
    subProduct28:
      "3823 19 Asam lemak monokarboksilat industri; minyak asam dari penyulingan (tidak termasuk asam stearat, asam oleat dan asam lemak minyak tinggi)",
    subProduct29: "3823 70 Alkohol lemak industri",
    subProduct30:
      "4001 Karet alam, balata, gutta-percha, guayule, chicle dan getah alam semacam itu, dalam bentuk asal atau dalam bentuk pelat, lembaran atau strip",
    subProduct31:
      "4005 Karet majemuk, tidak divulkanisasi, dalam bentuk asal atau dalam pelat, lembaran atau strip",
    subProduct32:
      "4006 Karet yang tidak divulkanisasi dalam bentuk lain (misalnya batangan, tabung dan bentuk profil) dan barang (misalnya cakram dan cincin)",
    subProduct33: "4007 Benang dan tali karet yang divulkanisasi",
    subProduct34:
      "4008 Pelat, lembaran, strip, batang dan bentuk profil, dari karet vulkanisasi selain karet keras",
    subProduct35:
      "4010 Belt atau belting pengangkut atau transmisi, dari karet vulkanisasi",
    subProduct36: "4011 Ban pneumatik baru, dari karet",
    subProduct37:
      "4012 Ban pneumatik vulkanisir atau bekas dari karet; ban padat atau bantalan, tapak ban dan penutup ban, dari karet",
    subProduct38: "4013 Ban dalam, dari karet",
    subProduct39:
      "4015 Pakaian dan aksesoris pakaian (termasuk sarung tangan, sarung tangan dan mitt), untuk segala keperluan, dari karet vulkanisasi selain karet keras",
    subProduct40:
      "4016 Barang lain dari karet vulkanisasi selain karet keras, tidak dirinci pada pos lain dalam Bab 40",
    subProduct41:
      "4017 Karet keras (misalnya ebonit) dalam segala bentuk termasuk sisa dan skrap; barang dari karet keras",
    subProduct42: "1201 Kacang kedelai, pecah maupun tidak",
    subProduct43: "1208 10 Tepung dan tepung kacang kedelai",
    subProduct44:
      "1507 Minyak kacang kedelai dan fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia",
    subProduct45:
      "2304 Bungkil minyak dan residu padat lainnya, digiling atau tidak atau dalam bentuk pelet, hasil ekstraksi minyak kacang kedelai",
    subProduct46:
      "4401 Kayu bakar, dalam bentuk batang kayu, dalam billet, dalam ranting, dalam kayu bakar atau dalam bentuk semacam itu; kayu dalam bentuk serpihan atau partikel; serbuk gergaji dan limbah serta skrap kayu, diaglomerasi maupun tidak dalam bentuk kayu bulat, briket, pelet atau bentuk semacam itu",
    subProduct47:
      "4402 Arang kayu (termasuk arang tempurung atau arang kacang), diaglomerasi maupun tidak",
    subProduct48:
      "4403 Kayu dalam keadaan kasar, dikupas kulit kayu atau gubalnya maupun tidak, atau berbentuk persegi kasar",
    subProduct49:
      "4404 Kayu Hoop; tiang terbelah; tiang pancang, tiang pancang dan tiang pancang dari kayu, runcing tetapi tidak digergaji memanjang; tongkat kayu, dipotong secara kasar tetapi tidak dibalik, dibengkokkan atau dikerjakan dengan cara lain, cocok untuk pembuatan tongkat jalan, payung, gagang perkakas atau sejenisnya; kayu chip dan sejenisnya",
    subProduct50: "4405 Wol kayu; tepung kayu",
    subProduct51:
      "4406 Bantalan rel kereta api atau trem (ikatan silang) dari kayu",
    subProduct52:
      "4407 Kayu digergaji atau dikelupas memanjang, diiris atau dikupas, diketam, diampelas atau disambung ujung maupun tidak, dengan ketebalan melebihi 6 mm",
    subProduct53:
      "4408 Lembaran untuk pelapisan (termasuk yang diperoleh dengan cara mengiris kayu yang dilaminasi), untuk kayu lapis atau untuk kayu laminasi yang serupa lainnya dan kayu lainnya, digergaji memanjang, diiris atau dikupas, diratakan, diamplas, disambung atau disambung ujung maupun tidak, dengan ketebalan tidak melebihi 6mm",
    subProduct54:
      "4409 Kayu (termasuk strip dan friezes untuk lantai parket, tidak dirakit) dibentuk terus menerus (berlidah, beralur, rabat, dilubangi, bersendi V, manik-manik, dibentuk, dibulatkan atau sejenisnya) di sepanjang tepi, ujung atau mukanya, baik atau tidak direncanakan, diampelas atau bersendi ujung",
    subProduct55:
      "4410 Papan partikel, papan untai berorientasi (OSB) dan papan semacam itu (misalnya, papan wafer) dari kayu atau bahan mengandung lignin lainnya, diaglomerasi dengan resin atau bahan pengikat organik lainnya maupun tidak",
    subProduct56:
      "4411 Papan serat dari kayu atau bahan mengandung lignin lainnya, direkatkan dengan resin atau bahan organik lainnya maupun tidak",
    subProduct57: "4412 Kayu lapis, panel veneer dan kayu laminasi semacam itu",
    subProduct58:
      "4413 Kayu dipadatkan, dalam bentuk balok, pelat, strip atau profil",
    subProduct59:
      "4414 Bingkai kayu untuk lukisan, foto, cermin atau benda semacam itu",
    subProduct60:
      "4415 Kotak pengepakan, kotak, peti, drum dan pengepakan semacam itu, dari kayu; drum kabel dari kayu; palet, palet kotak dan papan muatan lainnya, dari kayu;",
    subProduct61:
      "kerah palet dari kayu (tidak termasuk bahan pengemas yang digunakan secara eksklusif sebagai bahan pengemas untuk menopang, melindungi atau membawa produk lain yang dipasarkan)",
    subProduct62:
      "4416 Tong, tong, tong, bak dan produk-produk tembaga lainnya serta bagiannya, dari kayu, termasuk tongkat",
    subProduct63:
      "4417 Perkakas, badan perkakas, gagang perkakas, badan dan gagang sapu atau sikat, dari kayu; bahan boot atau sepatu dan pohon, dari kayu",
    subProduct64:
      "4418 Pekerjaan tukang kayu dan pertukangan dari kayu, termasuk panel kayu seluler, panel lantai rakitan, sirap dan getar",
    subProduct65: "4419 Peralatan makan dan dapur, dari kayu",
    subProduct66:
      "4420 Kayu marquetry dan kayu hias; peti mati dan kotak untuk perhiasan atau peralatan makan, dan barang semacam itu, dari kayu; patung-patung dan hiasan lainnya, dari kayu; perabot kayu tidak termasuk dalam Bab 94",
    subProduct67: "4421 Barang lainnya dari kayu",
    subProduct68:
      "Pulp dan kertas dari Bab 47 dan 48 dari Tata Nama Gabungan, dengan pengecualian produk berbahan dasar bambu dan produk hasil daur ulang (limbah dan skrap)",
    subProduct69:
      "49 Buku cetak, surat kabar, gambar dan produk industri percetakan lainnya, manuskrip, naskah ketikan dan denah, dari kertas",
    subProduct70:
      "9401 Tempat duduk (selain yang dimaksud dalam pos 9402), dapat diubah menjadi tempat tidur maupun tidak, dan bagiannya, dari kayu",
    subProduct71:
      "9403 30 , 9403 40 , 9403 50 , 9403 60 dan 9403 91 Perabotan kayu dan bagiannya",
    subProduct72: "9406 10 Bangunan prefabrikasi dari kayu",

    selectStatus: "Pilih Status",
    compilanceRiskWarning: "Peringatan Risiko Kepatuhan",
    operatorDeclerationTT: "Pernyataan pernyataan oleh operator.",
    supplierDeclerationTT: "Pernyataan pernyataan oleh pemasok.",

    blockchainVerifikasi: "Verifikasi Blockchain",
    scanQrBlockchain:
      "Pindai kode QR ini untuk melihat Laporan Uji Tuntas EUDR di blockchain.",
    unduhQrCode: "Unduh Kode QR",
    eudrPublicReport: "Laporan Publik Uji Tuntas Dimitra EUDR",
    scanQrEudr:
      "Pindai kode QR ini untuk melihat Laporan Uji Tuntas EUDR di web publik.",
    viewReportForPublic: "Klik Disini untuk Melihat Laporan untuk Publik",
    viewReportOnBlockChain: "Klik Disini untuk Melihat Laporan di Blockchain",
    riskAssessmentNotApproved: "tempat produksi tidak disetujui.",

    declarationMissing: "Deklarasi Hilang",
    removeRiskFarms: "HAPUS PERTANIAN BERISIKO",
    disregardRiskDocument: "ABAIKAN PERTANIAN BERISIKO",
    attachRiskMitigationDocumentForNonCompliantFarms: "LAMPIRKAN DOKUMEN MITIGASI RISIKO UNTUK SEMUA PERTANIAN YANG TIDAK PATUH",
    uploadMitigationDocumentForNonCompliantFarms: `Mengunggah dokumen mitigasi risiko untuk semua pertanian yang tidak patuh akan mengubah status pertanian dengan "Mitigasi Diperlukan" menjadi "Dimitigasi Secara Manual".`,
    disregardFarmWithIssuesTitle: "Abaikan Pertanian",
    disregardFarmWithIssuesMessage: "Dengan memilih 'Abaikan,' status penilaian risiko yang hilang untuk pertanian tidak akan dipertimbangkan dalam laporan ini. Pertanian akan tetap menjadi bagian dari laporan, tetapi penilaian yang tertunda tidak akan mempengaruhi status kepatuhan. Harap konfirmasi bahwa Anda ingin melanjutkan.",
    removeRiskFarmTitle: "Hapus Pertanian",
    removeRiskFarmMessage: "Dengan memilih 'Hapus,' pertanian dengan penilaian risiko yang hilang akan dihapus dari laporan. Harap konfirmasi bahwa Anda ingin melanjutkan.",

    fileName: "Nama file",
    dateAndTime: "Tanggal dan waktu",
    downloadProgressStatus: "Status kemajuan unduhan",
    downloadHistory: "Riwayat unduhan",
    downloaded: "Diunduh",
    inprogress: "Sedang berlangsung",
    failed: "Gagal",
    showAllDownloads: "Tampilkan semua unduhan",
    inProgress: "Sedang berlangsung",
    downloadCompleted: "Unduhan selesai",
    downloadFailed: "Unduhan gagal",
    errorDeletingItem: "Tidak dapat menghapus item. Silakan coba lagi nanti.",
    anErrorOccuredPlsTryAgain: "Terjadi kesalahan. Silakan coba lagi.",
    invalidData: "Data yang diberikan tidak valid. Silakan periksa dan coba lagi.",
    fileIsReady: "File siap digunakan",
    invalidFilePathOrUrl: "Path atau URL file tidak valid.",
    errorDownloadingFile: "Ada masalah saat mengunduh file. Silakan coba lagi.",
    downloadInitiated: "Unduhan dimulai",
    beingDownloaded: "sedang diunduh. Waktu estimasi",

    multiStepSurveyDetails: "Berdasarkan jumlah pertanyaan dalam satu langkah, semua pertanyaan dalam survei akan dikelompokkan dan ditampilkan dalam langkah-langkah. Namun, konfigurasi ini hanya tersedia sebelum menambahkan pertanyaan atau subjudul. Setelah pertanyaan atau subjudul ditambahkan, konfigurasi Multi-Langkah akan dinonaktifkan secara otomatis. Silakan hapus pertanyaan atau subjudul untuk mengaktifkan kembali opsi ini.",
    estimatedTime: "Waktu perkiraan",
    tryAgain: "Coba lagi"

  },
  diligenceGuide: {
    guide: "Panduan",
    downloadPdfManual: "Unduh Manual PDF",
    watchDemoVideo: "Tonton Video Demo",
    viewManualOnWeb: "Lihat Manual di Web",
  },
  welcomeScreenDiligenceGuide: {
    title: "Pusat Panduan Esensial Anda",
    description: `Jelajahi halaman Panduan Bantuan Sistem Due Diligence EUDR kami untuk sumber daya penting
          termasuk manual PDF, tutorial video, dan bantuan berbasis web. Berdayakan diri Anda untuk menavigasi platform secara efisien
          dan optimalkan alur kerja Anda.`,
    continueToTheDueDiligenceSystem: "Lanjutkan ke Sistem Due Diligence",
  },
  containerTypes: {
    standardDry: "Kontainer Kering Standar (20ft, 40ft)",
    highCube: "Kontainer Kubus Tinggi",
    openTop: "Kontainer Atas Terbuka",
    flatRack: "Kontainer Rak Datar",
    refrigerated: "Kontainer Berpendingin (Reefer)",
    tank: "Kontainer Tangki",
    ventilated: "Kontainer Berventilasi",
    insulated: "Kontainer Berinsulasi",
    platform: "Kontainer Platform",
    halfHeight: "Kontainer Setengah Tinggi",
    bulk: "Kontainer Curah",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Ringkasan Penilaian Risiko",
    riskAssessmentSummaryTT: "Ringkasan Penilaian Risiko",
    totalNoOfFarms: "Jumlah Total Peternakan",
    assessmentsCompleted: "Penilaian Selesai",
    assessmentsPending: "Penilaian Tertunda",
    requiredMitigation: "Mitigasi Diperlukan",
  }
};
